<template>
  <div>
    <div class="mb-3 richmenu-head">
      <div class="text-center richmenu-head-text">Event/News</div>
    </div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 50px; padding-top: 0px">
        <v-img
          style="margin-left: auto; margin-right: auto"
          width="80px"
          src="../../assets/depa.png"
        ></v-img>
      </div>

      <div class="px-7" style="font-size: 24px; font-weight: 600">Seminar</div>
      <div class="mt-2">
        <div style="height: 170px">
          <img
            width="100%"
            style="height: 100%; object-fit: cover"
            src="../../assets/depadark.png"
          />
        </div>
        <div
          class="px-9 py-3"
          style="background-color: #efefef; line-height: 16px"
        >
          <div style="font-weight: 900">Seminar 01</div>
          <div class="px-3" style="font-size: 12px">รายละเอียด</div>
          <div style="height: 30px"></div>
        </div>
      </div>
      <div class="mt-0">
        <div style="height: 170px">
          <img
            width="100%"
            style="height: 100%; object-fit: cover"
            src="../../assets/depa.png"
          />
        </div>
        <div
          class="px-9 py-3"
          style="background-color: #efefef; line-height: 16px"
        >
          <div style="font-weight: 900">Seminar 02</div>
          <div class="px-3" style="font-size: 12px">รายละเอียด</div>
          <div style="height: 30px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "event",
    };
  },
};
</script>

<style lang="scss" >
notActiveEvent {
  color: #152d53;
  font-weight: 900 !important;
}
.richmenu-head {
  height: 60px;
  background-color: #152d53;
  display: flex;
  justify-content: center;
}
.richmenu-head-text {
  line-height: 22px;
  font-size: 27px;
  font-weight: 400;
  color: white;
  align-self: center;
  word-break: break-word;
}
</style>